import { render, staticRenderFns } from "./EditPartnerSiteCustomTranslationModal.vue?vue&type=template&id=65071832&"
import script from "./EditPartnerSiteCustomTranslationModal.vue?vue&type=script&lang=js&"
export * from "./EditPartnerSiteCustomTranslationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports